// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.date-time-picker .v-card[data-v-f503b48e] {
  box-shadow: none;
}
.date-time-picker .v-picker--date.v-card[data-v-f503b48e] {
  width: 100%;
}
.date-time-picker .container[data-v-f503b48e] {
  margin: 0;
  padding: 0;
}
.date-time-picker[data-v-f503b48e] .v-picker__body {
  flex: none;
  margin-top: 10px;
}
.date-time-picker[data-v-f503b48e] .v-date-picker-years {
  max-height: 274px;
} /*to match the height of both datepicker and timepicker */
.date-time-picker[data-v-f503b48e] .v-picker--time {
  min-height: 296px;
} /*to match the height of both datepicker and timepicker */
.date-time-picker .container[data-v-f503b48e],
.date-time-picker .flex[data-v-f503b48e] {
  padding: 0;
} /* to set datetimepicker space to be 0 */
.date-time-picker[data-v-f503b48e] .time-picker-clock {
  background: rgba(0, 0, 0, 0.05);
} /* lighten the background */
.date-time-picker[data-v-f503b48e] .time-picker-clock__container {
  align-items: flex-start;
  padding: 0;
  height: 270px !important;
}
.date-time-picker[data-v-f503b48e] .time-picker-clock > span {
  font-size: 14px;
  line-height: 18px;
} /*reduced the font-size to set with theme*/
.date-time-picker[data-v-f503b48e] .v-picker__body {
  display: flex;
  justify-content: center;
} /*to create column structure*/
.date-time-picker .left-part[data-v-f503b48e] {
  position: relative;
  color: #ffffff;
} /*styling of the left custom part*/
.date-time-picker .left-part .activators[data-v-f503b48e] {
  position: absolute;
  bottom: 10px;
  left: 10px;
  right: 10px;
  display: flex;
  flex-grow: 1;
  justify-content: space-between;
} /*to align the activators in the bottom of the block*/
.date-time-picker .left-part .activators div[data-v-f503b48e] {
  cursor: pointer;
} /* to let cursor visible */
.date-time-picker .left-part i[data-v-f503b48e] {
  color: #ffffff;
} /* color styling of icons */
.c-datepicker__header[data-v-f503b48e] {
  text-align: center;
} /*styling of the left custom part*/
.c-datepicker__header-day[data-v-f503b48e] {
  padding: 10px;
  font-size: 17px;
  line-height: 21px;
  background: rgba(0, 0, 0, 0.2);
} /*styling of the left custom part*/
.c-datepicker__header-date[data-v-f503b48e] {
  padding: 30px 10px;
} /*styling of the left custom part*/
.c-datepicker__header-date > span[data-v-f503b48e] {
  display: block;
  font-size: 16px;
  line-height: 19px;
  margin-bottom: 10px;
} /*styling of the left custom part*/
.c-datepicker__header-date > span.js-date-day[data-v-f503b48e] {
  line-height: 64px;
  font-size: 60px;
} /*styling of the left custom part*/

/*Current time icon*/
.time-access-content[data-v-f503b48e] {
  position: relative !important;
}
.time-access-content .present-time[data-v-f503b48e] {
  position: absolute;
  right: -4px;
  top: 12px;
  height: 34px;
  width: 36px;
  text-align: right;
  margin-right: 3px;
  z-index: 1;
}
.time-access-content[data-v-f503b48e] .v-input {
  padding-right: 30px;
}
.time-access-content .present-time[data-v-f503b48e] .v-icon {
  cursor: pointer;
}
.calendar-menu[data-v-f503b48e] .v-input .v-text-field__slot input {
  padding-right: 30px;
  background-image: url(/img/calendar-ic.svg);
  background-size: 18px;
  background-repeat: no-repeat;
  background-position: right 6px;
  cursor: pointer;
  margin-right: 3px;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
